import React from 'react';
import { motion } from 'framer-motion';

const GraduationBanner = () => {
  return (
    <section className="px-6 md:px-10 pb-16">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 1.0, ease: [0.22, 1, 0.36, 1] }}
        className="max-w-7xl mx-auto hero-image-rounded aspect-[16/6] md:aspect-[16/5]"
      >
        <img src="/images/graduation-cap.png" alt="Graduation cap and diploma" className="w-full h-full object-cover" />
      </motion.div>
    </section>
  );
};

export default GraduationBanner;
